const nameSpace = 'snackbar'

export const snackbarType = {
  DEFAULT: 'DEFAULT',
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
  ERROR: 'ERROR',
}

export const colorType = {
  DEFAULT: 'info',
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const mutations = {
  SET_SNACKBAR: `${nameSpace}/SET_SNACKBAR`,
}

export const actions = {
  SHOW_SNACKBAR: `${nameSpace}/SHOW_SNACKBAR`,
  RESET_SNACKBAR: `${nameSpace}/RESET_SNACKBAR`,
  CLOSE_SNACKBAR: `${nameSpace}/CLOSE_SNACKBAR`,
}

export const getters = {
  openFlag: `${nameSpace}/openFlag`,
  message: `${nameSpace}/message`,
  color: `${nameSpace}/color`,
  textColor: `${nameSpace}/textColor`,
}
